:host {
    display: grid;
    gap: 10px;
    padding: 30px 15px;
    margin: 0;

    @media (min-width: 380px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 568px) {
        padding: 30px;
    }

    @media (min-width: 768px) {
        grid-template-columns: repeat(4, 1fr);
    }

    @media (min-width: 1024px) {
        padding-left: calc(100% / 12);
        padding-right: calc(100% / 12);
        padding-bottom: 60px;
        padding-top: 60px;
    }
}
